import {
  generateGetInfiniteResourceKey,
  generateGetResourceKey,
  generateHttpGet,
} from "../../utils/fetcherUtils";

import { Params, Result } from "./typing";

export const httpGet$GetSecondaryArtworkFilterData = generateHttpGet<
  Params,
  Result
>(Result.parse);

export const getResourceKey$GetSecondaryArtworkFilterData =
  generateGetResourceKey<Params>(["9e4e9eb5-8105-40cc-b0e9-42a48a23bb21"]);

export const getInfiniteResourceKey$GetSecondaryArtworkFilterData =
  generateGetInfiniteResourceKey<Params>([
    "9e4e9eb5-8105-40cc-b0e9-42a48a23bb21",
  ]);
